/* Jamal Al Muhra — PDP enhancements: mobile sticky add-to-cart. */
(function () {
  var buttons = document.querySelector('.product-form__buttons');
  var bar = document.querySelector('[data-jam-sticky-atc]');
  if (!buttons || !bar) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('jam-atc-visible', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    });
  }, { threshold: 0 });
  io.observe(buttons);

  bar.querySelector('[data-jam-sticky-add]').addEventListener('click', function () {
    var submit = document.querySelector('.product-form__submit');
    if (submit && !submit.disabled) submit.click();
  });
})();

/* Estimated delivery range — deliberately conservative: 1–2 working days,
   2 pm Dubai cutoff, no deliveries counted on Sunday. Labeled "estimated". */
(function () {
  var eta = document.querySelector('[data-jam-eta]');
  if (!eta) return;
  var locale = eta.dataset.jamEtaLocale === 'ar' ? 'ar' : 'en';

  function dubaiNow() {
    // formatToParts is deterministic across browsers — no date-string parsing (Safari-safe)
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Dubai', year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false
    }).formatToParts(new Date());
    var v = {};
    parts.forEach(function (x) { if (x.type !== 'literal') v[x.type] = parseInt(x.value, 10); });
    return new Date(v.year, v.month - 1, v.day, v.hour === 24 ? 0 : v.hour, v.minute, v.second);
  }
  function addDeliveryDays(date, days) {
    var d = new Date(date);
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) days--; // couriers rest on Sunday
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString(locale === 'ar' ? 'ar-AE' : 'en-GB',
      { weekday: 'short', day: 'numeric', month: 'long' });
  }

  var now = dubaiNow();
  var base = new Date(now);
  if (now.getHours() >= 14) base.setDate(base.getDate() + 1); // past cutoff
  var from = addDeliveryDays(base, 1);
  var to = addDeliveryDays(base, 2);

  var text = locale === 'ar'
    ? 'التوصيل المتوقع: ' + fmt(from) + ' – ' + fmt(to)
    : 'Estimated delivery: ' + fmt(from) + ' – ' + fmt(to);
  eta.querySelector('[data-jam-eta-text]').textContent = text;
  eta.hidden = false;
})();

/* Brand rule: no emojis in customer-facing content — strip them from
   product descriptions and tab content even when the admin copy has them. */
(function () {
  var emoji;
  try {
    emoji = new RegExp('[\\p{Extended_Pictographic}\\u{FE0F}\\u{2700}-\\u{27BF}\\u{2B00}-\\u{2BFF}\\u{1F000}-\\u{1FAFF}]', 'gu');
  } catch (_) { return; }
  function clean(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (emoji.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(emoji, '').replace(/^[\s ]+/, '');
      }
      emoji.lastIndex = 0;
    }
  }
  function run() {
    document.querySelectorAll('.product__description, .tab-content, .accordion__content').forEach(clean);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* sticky bar price follows the selected variant */
(function () {
  var bar = document.querySelector('[data-jam-sticky-atc]');
  if (!bar) return;
  var barPrice = bar.querySelector('.jam-sticky-atc__price');
  var src = document.querySelector('.product__info-container .price');
  if (!barPrice || !src) return;
  function firstMoney() {
    var t = src.textContent || '';
    var m = t.match(/(?:Dhs\.?|AED|د\.إ|⃃)\s?[\d.,٠-٩]+|[\d.,٠-٩]+\s?(?:AED|د\.إ|⃃)/);
    return m ? m[0].trim() : null;
  }
  new MutationObserver(function () {
    var v = firstMoney();
    if (v) barPrice.textContent = v;
  }).observe(src, { childList: true, subtree: true, characterData: true });
})();

/* jam-weight: keep the gold-weight line in sync with the selected variant.
   Primary: parse the grams straight off the chosen option control (works even
   if the vendor variant JS is slow or fails). Fallback: variant-id map. */
document.addEventListener('change', function (e) {
  var t = e.target;
  if (!t.closest('variant-radios,variant-selects,.product_form_input,.product__info-container')) return;
  var raw = null;
  if (t.type === 'radio' && t.checked) raw = t.value;
  else if (t.tagName === 'SELECT') raw = t.value;
  var parseG = function (str) {
    if (!str) return null;
    var seg = null;
    String(str).toLowerCase().split('/').forEach(function (p) {
      p = p.trim();
      if (/mm|ملم|مم/.test(p)) return;
      if (/g|جرام|غرام|جم/.test(p)) seg = p;
    });
    if (!seg) return null;
    seg = seg.replace(/grams|gram|gm|g|غرام|جرام|جم|غ/g, '').trim();
    return /^[0-9٠-٩]/.test(seg) ? seg : null;
  };
  var direct = parseG(raw);
  setTimeout(function () {
    document.querySelectorAll('[data-jam-weight]').forEach(function (el) {
      var out = el.querySelector('[data-jam-weight-val]');
      if (direct) { out.textContent = direct; return; }
      var scope = el.closest('.wbpricetax') || document;
      var mapEl = scope.querySelector('[data-jam-weight-map]');
      if (!mapEl) return;
      var map; try { map = JSON.parse(mapEl.textContent); } catch (_) { return; }
      var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var val = idInput && map[idInput.value];
      if (val) out.textContent = val;
    });
  }, 80);
});

/* jam-size (chains): keep the chain-length line in sync with the selected
   variant — same direct-parse trick as the weight line. Inches segment is
   recognised by "/”/inch/بوصة, converted with the jeweller's chart values. */
document.addEventListener('change', function (e) {
  var line = document.querySelector('[data-jam-chainlen]');
  if (!line) return;
  var t = e.target;
  if (!t.closest('variant-radios,variant-selects,.product_form_input,.product__info-container')) return;
  var raw = null;
  if (t.type === 'radio' && t.checked) raw = t.value;
  else if (t.tagName === 'SELECT') raw = t.value;
  if (!raw) return;
  var seg = null;
  String(raw).split('/').forEach(function (p) {
    p = p.trim();
    if (/["”]|inch|بوصة/i.test(p)) seg = p;
  });
  if (!seg) return;
  seg = seg.toLowerCase().replace(/size|مقاس|["”]|inches|inch|بوصة/g, '').trim();
  if (!/^[0-9٠-٩]/.test(seg)) return;
  var CM = { '16': '40.5', '18': '45.5', '20': '51', '22': '56', '24': '61' };
  var cm = CM[seg] || (parseFloat(seg) ? (Math.round(parseFloat(seg) * 25.4) / 10).toFixed(1) : null);
  var ar = line.hasAttribute('data-jam-chainlen-ar');
  var out = line.querySelector('[data-jam-size-val]');
  if (out) out.textContent = ar
    ? seg + ' بوصة' + (cm ? ' · ' + cm + ' سم' : '')
    : seg + '″' + (cm ? ' · ' + cm + ' cm' : '');
});
